// import "core-js";
import FixedHeader from "./components/fixed-header";
import StickyHeader from "./components/sticky-header";
import TouchMenu from "./components/touch-menu";
import GeckoSlideshow from "./components/gecko-slideshow";
import Accordion from "./components/accordion";
import ScrollSpy from "./components/scrollspy";

import Parallax from "./components/parallax";
import SmoothScroll from "./components/smooth-scroll";

import LocationMap from "./components/location-map";
import FooterBar from "./FrealLocator/footer-bar";

import Products from "./Products";
import ProductModal from "./Products/modal";
import FloatingLabels from "./components/floating-label";
import FormsHandler from "./components/forms-handler";

import GridLayout from "./components/grid-layout";

import {SvgAnimations, HeaderAnimations} from "./components/svg-animations";
import OurStory from "./our-story";
import Promotions from "./promotions";

import * as $ from "jquery";
import "./weak";

$(document).ready(() => {
	// Load Location Map if elements exist
	let locationMap = new LocationMap();

	const productsWrapper = <HTMLElement> document.querySelector('section.products-wrapper');
	if (productsWrapper) {
		const products = new Products(productsWrapper);
	}

	const singleModal = <HTMLElement> document.querySelector('[data-modal="single-product-details"]');
	if (singleModal) {
		const modal = new ProductModal('single-product-details');
		const modalToggler = <HTMLElement> document.querySelector('.modal--toggle');

		modalToggler.addEventListener("click", (e) => {
			const target = <HTMLElement> e.target;
			const productId = target.getAttribute('data-pid');

			const jsonDeets = document.querySelector('[data-details="'+productId+'"]');
			let factsEl = <HTMLElement> document.querySelector('.freal-nutrition-facts__wrapper');
			if (!factsEl) {
				factsEl = document.createElement('div');
			}
			if (jsonDeets) {
				const details = JSON.parse(jsonDeets.innerHTML);
				modal.updateContent(details, factsEl);
				modal.show();
			}
		});
	}

	// Look for touch menus
	const menu = TouchMenu.searchAndLoadOne();

	// Look for fixed header elements
	FixedHeader.searchAndLoad()
		.forEach(header => {
			header.watch();

			const toggleEl = <HTMLElement>header.element.querySelector(`[data-action="toggle-touch-menu"]`);
			if (toggleEl) {
				menu.toggleEl = toggleEl;
			}

			if (toggleEl) {
				toggleEl.addEventListener("click", () => {
					menu.toggle();
				});
			}
		});

	// Sticky Header functions
	let stickyHeader = new StickyHeader(document.querySelector("header[data-sticky-header]"));
	let lastPosition = -1;

	const footerBar = document.getElementById("footer-location-finder");
	let fb = null;
	if (footerBar) {
		fb = new FooterBar();
	}

	let spy = new ScrollSpy();

	let parallax = new Parallax();
	let smoothScroll = new SmoothScroll();

	const gridLayouts = new GridLayout();

	function mainLoop() {
		if (lastPosition == window.pageYOffset) {
			requestAnimationFrame(mainLoop);
			return false;
		} else {
			lastPosition = window.pageYOffset;

			if(stickyHeader) {
				stickyHeader.checkSticky()
			}

			if (spy != null) {
				spy.checkBodySections();
			}

			if (parallax != null) {
				parallax.scrollUpdate(lastPosition);
			}

			// Adopted this method to strip from the plugin file
			if (fb != null) {
				fb.checkSticky();
			}
		}
		requestAnimationFrame(mainLoop);
	}
	mainLoop();


	// Init all SVG animations
	const svgsAnims = new SvgAnimations();
	const headerAnims = new HeaderAnimations();

	const ourStoryEl = <HTMLElement>document.querySelector('body > main.wtf');
	if (ourStoryEl) {
		const ourStory = new OurStory(ourStoryEl);
	}

	const promotionsEl = <HTMLElement>document.querySelector('body > main.promotions');
	if (promotionsEl) {
		const promotions = new Promotions(promotionsEl);
	}

	// Init all of the accordions on the page
	$('.accordion__wrapper').each((i, el) => {
		new Accordion(<HTMLElement>el);
	});

	$('.float-label').each((i, el) => {
		const item = new FloatingLabels(el);
	});

	$('.gecko-slideshow__container').each((i, el) => {
		const slideshow = new GeckoSlideshow(<HTMLElement>el);
	});

	const formWrapper = document.querySelector('.ContactForm__wrapper');
	if (formWrapper) {
		const formEl = new FormsHandler(formWrapper);
	}

});